var map = {
	"./1INCH.svg": 1779,
	"./AAVE.svg": 3308,
	"./ADA.svg": 6929,
	"./AION.svg": 7488,
	"./AKRO.svg": 1130,
	"./ALGO.svg": 7960,
	"./ALPHA.svg": 2046,
	"./AMP.svg": 9109,
	"./AMPL.svg": 1078,
	"./ANKR.svg": 3030,
	"./ANT.svg": 7803,
	"./AR.svg": 5345,
	"./ARDR.svg": 3722,
	"./ARK.svg": 998,
	"./ATOM.svg": 1656,
	"./AUDIO.svg": 4123,
	"./AVA.svg": 2371,
	"./AVAX.svg": 5473,
	"./AXS.svg": 7316,
	"./BADGER.svg": 9745,
	"./BAL.svg": 6597,
	"./BAND.svg": 3403,
	"./BAO.svg": 9205,
	"./BAT.svg": 515,
	"./BCH.svg": 4370,
	"./BLZ.svg": 789,
	"./BNB.svg": 5421,
	"./BNT.svg": 9895,
	"./BSV.svg": 796,
	"./BTC.svg": 4302,
	"./BTMX.svg": 5136,
	"./BTS.svg": 5205,
	"./BTT.svg": 1383,
	"./BZRX.svg": 2963,
	"./CAKE.svg": 1652,
	"./CEL.svg": 4316,
	"./CELO.svg": 6891,
	"./CELR.svg": 1394,
	"./CHSB.svg": 1458,
	"./CHZ.svg": 7718,
	"./CKB.svg": 578,
	"./COMP.svg": 2698,
	"./COTI.svg": 1519,
	"./CREAM.svg": 5581,
	"./CRO.svg": 6240,
	"./CRV.svg": 341,
	"./CTK.svg": 8230,
	"./CVC.svg": 2635,
	"./DAI.svg": 1681,
	"./DASH.svg": 1587,
	"./DCR.svg": 6687,
	"./DF.svg": 8483,
	"./DGB.svg": 17,
	"./DNT.svg": 8505,
	"./DODO.svg": 173,
	"./DOGE.svg": 2346,
	"./DOT.svg": 3050,
	"./DPI.svg": 2753,
	"./DUSK.svg": 8853,
	"./EGLD.svg": 2702,
	"./ELON.svg": 2287,
	"./ENJ.svg": 1234,
	"./EOS.svg": 913,
	"./ETC.svg": 6992,
	"./ETH.svg": 1007,
	"./EWT.svg": 5074,
	"./FARM.svg": 8258,
	"./FIL.svg": 6488,
	"./FLOW.svg": 9107,
	"./FRM.svg": 4914,
	"./FTM.svg": 763,
	"./FTT.svg": 6395,
	"./FUN.svg": 8994,
	"./GHST.svg": 6964,
	"./GLM.svg": 8078,
	"./GNO.svg": 2929,
	"./GRT.svg": 321,
	"./HARD.svg": 7554,
	"./HBAR.svg": 5904,
	"./HEGIC.svg": 7866,
	"./HIFI.svg": 8711,
	"./HIVE.svg": 6260,
	"./HNT.svg": 9210,
	"./HOT.svg": 6351,
	"./HT.svg": 3449,
	"./HXRO.svg": 931,
	"./ICX.svg": 1912,
	"./ILV.svg": 7733,
	"./INJ.svg": 9598,
	"./IOST.svg": 7582,
	"./IOTX.svg": 5085,
	"./KAVA.svg": 2163,
	"./KEEP.svg": 8995,
	"./KMD.svg": 6422,
	"./KNC.svg": 8277,
	"./KP3R.svg": 5906,
	"./KSM.svg": 8273,
	"./LEO.svg": 856,
	"./LINK.svg": 221,
	"./LOOM.svg": 4511,
	"./LRC.svg": 3091,
	"./LSK.svg": 8118,
	"./LTC.svg": 8429,
	"./LUNA.svg": 4382,
	"./MANA.svg": 1698,
	"./MAPS.svg": 3588,
	"./MASK.svg": 6586,
	"./MATIC.svg": 3937,
	"./MCO.svg": 443,
	"./MDX.svg": 1748,
	"./MFT.svg": 5344,
	"./MIOTA.svg": 1870,
	"./MIR.svg": 3529,
	"./MKR.svg": 1316,
	"./MTL.svg": 4496,
	"./NANO.svg": 8759,
	"./NEAR.svg": 2048,
	"./NEO.svg": 8712,
	"./NEXO.svg": 3853,
	"./NMR.svg": 1156,
	"./NPXS.svg": 7242,
	"./NRG.svg": 3925,
	"./NU.svg": 7528,
	"./NXM.svg": 8227,
	"./NXS.svg": 9760,
	"./OCEAN.svg": 8290,
	"./OGN.svg": 4264,
	"./OKB.svg": 7763,
	"./OMG.svg": 1494,
	"./OMI.svg": 1826,
	"./ONE.svg": 5062,
	"./ONT.svg": 6529,
	"./ORN.svg": 6581,
	"./PAXG.svg": 5298,
	"./PERP.svg": 884,
	"./POLS.svg": 9529,
	"./POLY.svg": 7375,
	"./POWR.svg": 1727,
	"./PPT.svg": 7515,
	"./PREMIA.svg": 7243,
	"./QKC.svg": 1706,
	"./QNT.svg": 3094,
	"./QTUM.svg": 8639,
	"./RARI.svg": 8399,
	"./REEF.svg": 1359,
	"./REN.svg": 7019,
	"./REP.svg": 6595,
	"./RFOX.svg": 9253,
	"./RGT.svg": 8631,
	"./RIF.svg": 1442,
	"./RLC.svg": 8535,
	"./ROOK.svg": 2519,
	"./ROSE.svg": 8089,
	"./RSR.svg": 209,
	"./RUNE.svg": 2279,
	"./RVN.svg": 7957,
	"./SAND.svg": 5327,
	"./SC.svg": 9574,
	"./SCRT.svg": 7900,
	"./SFI.svg": 1127,
	"./SFP.svg": 4096,
	"./SHIB.svg": 6254,
	"./SLP.svg": 9169,
	"./SNT.svg": 2730,
	"./SNX.svg": 9581,
	"./SOL.svg": 5363,
	"./SPELL.svg": 2381,
	"./SRM.svg": 34,
	"./STAKE.svg": 1986,
	"./STEEM.svg": 6219,
	"./STORJ.svg": 5836,
	"./STX.svg": 752,
	"./SUPER.svg": 8455,
	"./SUSHI.svg": 3069,
	"./SWAP.svg": 1474,
	"./SYS.svg": 6276,
	"./THETA.svg": 8761,
	"./TOMO.svg": 3365,
	"./TRB.svg": 922,
	"./TRX.svg": 5139,
	"./TWT.svg": 5261,
	"./UBT.svg": 8609,
	"./UMA.svg": 8590,
	"./UNI.svg": 7713,
	"./USDC.svg": 6113,
	"./USDE.svg": 2434,
	"./VET.svg": 7976,
	"./VGX.svg": 8062,
	"./WAN.svg": 2113,
	"./WAVES.svg": 4410,
	"./WRX.svg": 3967,
	"./XEM.svg": 9340,
	"./XLM.svg": 1014,
	"./XMR.svg": 4666,
	"./XRP.svg": 9439,
	"./XTZ.svg": 665,
	"./YFI.svg": 2281,
	"./YFII.svg": 5292,
	"./ZEC.svg": 6556,
	"./ZEN.svg": 8327,
	"./ZIL.svg": 5979,
	"./ZKS.svg": 7115,
	"./ZRX.svg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;